/* @flow */

import * as types from 'src/shared/app/market/action/uiMarketActionTypes';
import * as topicTypes from 'src/shared/domain/topic/action/topicActionTypes';

import {
  filterMenu,
  sortMenu,
  queryMenu,
} from 'src/shared/app/market/constant/marketConstants';
import { guidanceAddInterests } from 'src/shared/app/market/guidance/settings/guidanceSettings';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = {
  isMenuHiding: false,
  postedTopicID: 0,
  menu: null,
  isAutocompleteShown: false,
  topic: null,
  topicNotFound: false,
  isFrozen: false,
  hiddenPrompts: [],
};

const _setIsMenuHiding = (state: Object) => ({ ...state, isMenuHiding: true });

const _setFilterMenu = (state: Object) => ({ ...state, menu: filterMenu });

const _setSortMenu = (state: Object) => ({ ...state, menu: sortMenu });

const _setQueryMenu = (state: Object) => ({ ...state, menu: queryMenu });

const _resetMenu = (state: Object) => ({
  ...state,
  menu: null,
  isMenuHiding: false,
});

const _showAutocomplete = (state: Object) => ({
  ...state,
  isAutocompleteShown: true,
});

const _hideAutocomplete = (state: Object) => ({
  ...state,
  isAutocompleteShown: false,
});

const _setMarketTopicNotFoundError = (state: Object) => ({
  ...state,
  topicNotFound: true,
});

const _dismissMarketTopicNotFoundError = (state: Object) => ({
  ...state,
  topicNotFound: false,
});

const _setFirstTopic = (state: Object, action: Object) => {
  const { topicId: topic } = action;

  return {
    ...state,
    topic,
  };
};

const _resetFirstTopic = (state: Object) => ({
  ...state,
  topic: null,
});

const _freeze = (state: Object) => ({
  ...state,
  isFrozen: true,
});

const _unfreeze = (state: Object) => ({
  ...state,
  isFrozen: false,
});

const hideAddInterestsPrompt = (state: Object) => ({
  ...state,
  hiddenPrompts: [...state.hiddenPrompts, guidanceAddInterests],
});

export default createReducer(initialState, {
  [types.START_HIDING_MARKET_MENU]: _setIsMenuHiding,
  [types.SHOW_MARKET_QUERY_MENU]: _setQueryMenu,
  [types.HIDE_MARKET_QUERY_MENU]: _resetMenu,
  [types.SHOW_MARKET_FILTER_MENU]: _setFilterMenu,
  [types.HIDE_MARKET_FILTER_MENU]: _resetMenu,
  [types.SHOW_MARKET_SORT_MENU]: _setSortMenu,
  [types.HIDE_MARKET_SORT_MENU]: _resetMenu,
  [types.SHOW_MARKET_AUTOCOMPLETE]: _showAutocomplete,
  [types.HIDE_MARKET_AUTOCOMPLETE]: _hideAutocomplete,
  [types.SET_MARKET_FIRST_TOPIC]: _setFirstTopic,
  [types.RESET_MARKET_FIRST_TOPIC]: _resetFirstTopic,
  [types.DISMISS_MARKET_TOPIC_NOT_FOUND]: _dismissMarketTopicNotFoundError,
  [types.FREEZE_MARKET_TOPICS]: _freeze,
  [types.UNFREEZE_MARKET_TOPICS]: _unfreeze,
  [types.HIDE_ADD_INTERESTS_PROMPT]: hideAddInterestsPrompt,
  [topicTypes.FETCH_TOPIC_FAILURE]: _setMarketTopicNotFoundError,
});
